export function getCSRFTokenPage() {
  const tokenEl = document.querySelector<HTMLMetaElement>('[name="csrf-token"]')
  if (tokenEl) {
    return tokenEl.content
  }
}

export function getCSRFTokenCookie() {
  // This logic extracted from Axios
  const match = document.cookie.match(new RegExp('(^|;\\s*)(XSRF-TOKEN)=([^;]*)'))
  if (match) {
    return decodeURIComponent(match[3])
  }
}

export function getCSRFToken() {
  // Prefer the cookie -- this may have been updated from a second tab or window
  // for this same session.
  const tokenCookie = getCSRFTokenCookie()
  if (tokenCookie) {
    return tokenCookie
  }

  const tokenEl = document.querySelector<HTMLMetaElement>('[name="csrf-token"]')
  if (tokenEl) {
    return tokenEl.content
  }
}
